export const symbolLibrary: IconSymbol[] = [
  "circle",
  "diamond",
  "square",
  "pentagon",
  "hexagon",
  "parallelogramm",
  "clover",
  "drop"
];

export type IconSymbol =
  | "circle"
  | "diamond"
  | "square"
  | "pentagon"
  | "hexagon"
  | "parallelogramm"
  | "clover"
  | "drop";
